<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed, ref, watch } from 'vue'

const page = usePage()

const showFlash = ref(false)
const region = import.meta.env.VITE_FRONT_END_THEME

const flash = computed(function () {
    return page.props.flash
});
const continueLink = computed(function () {

    if(flash.message?.success.continue_link) {
        return flash.message?.success.continue_link
    }
    if(region =='SW') {
        return 'https://www.fosterwithyourlocalcouncil.org.uk/';
    }
    if(region =='SE') {
        return 'https://www.lafosteringse.org.uk/';
    }
    return ''
});

watch(page.props, function (val) {
    if (val?.flash) {
        showFlash.value = true
    }
}, {
    immediate: true,
    deep: true,
});

</script>

<template>
    <div v-if="flash.message || page.props.errors">
        <v-alert v-if="flash.message?.success" class="mb-5 mt-5" border="start" variant="tonal" type="success" :text="flash.message?.success?.message ? flash.message?.success.message : flash.message?.success">
            <v-btn :href="continueLink" class="float-right">
                Continue
            </v-btn>
        </v-alert>
        <v-alert v-if="flash.message?.info" class="mb-5" border="start" variant="tonal" type="info" :text="flash.message?.info?.message ? flash.message?.info.message : flash.message?.info">
            <v-btn v-if="flash.message?.info?.continue_link" :href="flash.message?.info.continue_link" class="float-right">
                Continue
            </v-btn>
        </v-alert>
        <v-alert v-if="flash.message?.error" class="mb-5" border="start" variant="tonal" type="error" :text="flash.message?.error?.message ? flash.message?.error.message : flash.message?.error">
            <v-btn v-if="flash.message?.error?.continue_link" :href="flash.message?.error.continue_link" class="float-right">
                Continue
            </v-btn>
        </v-alert>
        <v-alert v-else-if="page.props.errors && Object.keys(page.props.errors).length > 0" class="mb-5" border="start"
            variant="tonal" type="error"
            :text="'The following fields are required: ' + Object.values(page.props.errors).join(', ')"/>
        <v-alert v-if="flash.message?.warning" class="mb-5" border="start" variant="tonal" type="warning" :text="flash.message?.warning?.message ? flash.message?.warning.message : flash.message?.warning">
            <v-btn v-if="flash.message?.warning?.continue_link" :href="flash.message?.warning.continue_link" class="float-right">
                Continue
            </v-btn>
        </v-alert>
    </div>
</template>
